import { render, staticRenderFns } from "./ChannelSignUp.vue?vue&type=template&id=69e99592&scoped=true&"
import script from "./ChannelSignUp.vue?vue&type=script&lang=js&"
export * from "./ChannelSignUp.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSignUp.vue?vue&type=style&index=0&id=69e99592&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e99592",
  null
  
)

export default component.exports